import { Loader } from 'react-feather';

import styles from './LoadingSpinner.module.scss';

type LoadingSpinnerProps = {
  color?: string;
};

const LoadingSpinner = ({ color }: LoadingSpinnerProps) => {
  return (
    <div className={styles.spinner}>
      <Loader color={color} />
    </div>
  );
};

export default LoadingSpinner;
